export default "__VITE_ASSET__h2lepE7D__"